import React, { useContext } from "react";

import { DataContext } from "../../../../../../providers/ElectricityCheckoutDataProvider";
import Input from "../../../../../shared/forms/NewInput";
import { SalutationSelect } from "../../../../../shared/forms/NewSelect";
import Margin from "../../../../../shared/Margin";
import Section from "../../../../../shared/Section";

const DifferentAccountHolder = () => {
    const dataContext = useContext(DataContext);
    const { paymentData } = dataContext.data;
    const { setPaymentData, addFormError, clearFormError, hasFormErrorAt } =
        dataContext.actions;
    const handleChange = (event) => {
        setPaymentData({
            ...paymentData,
            ...{ [event.target.name]: event.target.value },
        });
    };
    return (
        <React.Fragment>
            <Section withMargin>
                <div className="field is-full-width">
                    <div className="field">
                        <div className="control">
                            <SalutationSelect
                                name="payment_salutation"
                                onChange={handleChange}
                                value={paymentData.payment_salutation}
                            />
                        </div>
                    </div>
                    <div className="field is-full-width">
                        <div className="control">
                            <Input
                                placeholder="Vorname"
                                name="payment_firstname"
                                onChange={handleChange}
                                value={paymentData.payment_firstname}
                                validation="name"
                                forceError={hasFormErrorAt("payment_firstname")}
                                onError={() =>
                                    addFormError("payment_firstname")
                                }
                                onErrorSolved={() =>
                                    clearFormError("payment_firstname")
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="field">
                    <div className="control">
                        <Input
                            placeholder="Nachname"
                            name="payment_lastname"
                            onChange={handleChange}
                            value={paymentData.payment_lastname}
                            validation="name"
                            forceError={hasFormErrorAt("payment_lastname")}
                            onError={() => addFormError("payment_lastname")}
                            onErrorSolved={() =>
                                clearFormError("payment_lastname")
                            }
                        />
                    </div>
                </div>
                <Margin top="20" className="field">
                    <div className="control">
                        <Input
                            placeholder="E-Mail"
                            name="payment_email"
                            onChange={handleChange}
                            value={paymentData.payment_email}
                            validation="email"
                            forceError={hasFormErrorAt("payment_email")}
                            onError={() => addFormError("payment_email")}
                            onErrorSolved={() =>
                                clearFormError("payment_email")
                            }
                        />
                    </div>
                </Margin>
                <div className="field">
                    <div className="control">
                        <Input
                            placeholder="Telefonnummer"
                            name="payment_phone"
                            onChange={handleChange}
                            value={paymentData.payment_phone}
                            validation="phone"
                            forceError={hasFormErrorAt("payment_phone")}
                            onError={() => addFormError("payment_phone")}
                            onErrorSolved={() =>
                                clearFormError("payment_phone")
                            }
                        />
                    </div>
                </div>

                <Input
                    value={paymentData.payment_street}
                    onChange={handleChange}
                    name="payment_street"
                    placeholder="Straße und Hausnummer"
                    validation="street"
                    forceError={hasFormErrorAt("payment_street")}
                    onError={() => addFormError("payment_street")}
                    onErrorSolved={() => clearFormError("payment_street")}
                />

                <div className="field">
                    <div className="control">
                        <Input
                            placeholder="Plz"
                            name="payment_zipcode"
                            onChange={handleChange}
                            value={paymentData.payment_zipcode}
                            fullWidth
                            validation="zipcode"
                            forceError={hasFormErrorAt("payment_zipcode")}
                            onError={() => addFormError("payment_zipcode")}
                            onErrorSolved={() =>
                                clearFormError("payment_zipcode")
                            }
                        />
                    </div>
                </div>
                <div className="field">
                    <div className="control">
                        <Input
                            placeholder="Ort"
                            name="payment_city"
                            onChange={handleChange}
                            value={paymentData.payment_city}
                            fullWidth
                            validation="city"
                            forceError={hasFormErrorAt("payment_city")}
                            onError={() => addFormError("payment_city")}
                            onErrorSolved={() => clearFormError("payment_city")}
                        />
                    </div>
                </div>
            </Section>
        </React.Fragment>
    );
};

export default DifferentAccountHolder;
